import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getApplicationSpaBackendUrl } from "@utils";
import { httpHeaders } from "@shared/constants/httpHeaders";
import { type TMagicLinkReason } from "@shared/types/magicLink.types";

interface ISendNewMagicLinkBody {
  token: string;
  pageUrl: string;
  email: string;
  reason: TMagicLinkReason;
}

interface ISendNewMagicLinkResponse {
  isSent: boolean;
}

export const magicLinkResendReducerKey = "magicLinkResendApi";
export const magicLinkResendApi = createApi({
  reducerPath: magicLinkResendReducerKey,
  baseQuery: fetchBaseQuery({ baseUrl: getApplicationSpaBackendUrl() }),
  endpoints: (builder) => ({
    sendNewMagicLink: builder.mutation<ISendNewMagicLinkResponse, ISendNewMagicLinkBody>({
      query: ({ token, pageUrl, email, reason }) => ({
        url: "/magic-link/resend",
        method: "POST",
        headers: { [httpHeaders.magicToken]: token },
        body: { pageUrl, email, reason },
      }),
    }),
  }),
});

export const { useSendNewMagicLinkMutation } = magicLinkResendApi;
